'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import {
    STORE_LOADING_COVER_LABEL_KEY,
    STORE_LOADING_COVER_TEST_IDS,
} from '../StoreLoadingCover.consts';

interface IStoreLoadingCoverLabelProps {
    fallbackLabel: string;
}

/**
 * Only English is bundled for the server, so the cover paints `fallbackLabel`
 * and this corrects to the visitor's language once i18next has fetched it.
 * The text legitimately differs between the server and a client that already
 * restored a non-English locale, hence `suppressHydrationWarning`.
 */
export function StoreLoadingCoverLabel({
    fallbackLabel,
}: IStoreLoadingCoverLabelProps): React.ReactElement {
    const { t, ready } = useTranslation();

    let label = fallbackLabel;
    if (ready) {
        label = t(STORE_LOADING_COVER_LABEL_KEY);
    }

    return (
        <span
            data-testid={STORE_LOADING_COVER_TEST_IDS.label}
            suppressHydrationWarning
        >
            {label}
        </span>
    );
}
